import { GetCategory200 } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import { IMAGE_TRANSFORM_CATEGORY } from './constants';
import Seo from './Seo';
import { getSeoImage } from './utils';

interface Props {
  category: GetCategory200;
}

export const SeoCategory = ({ category }: Props) => {
  const { image, slug, noIndex } = category;
  const { metaTitle, metaDescription, metaCanonical } = category;

  const canonicalUrl = metaCanonical ?? `/categorie/${slug}`;
  const imageUrl = image && getSeoImage(image.url, IMAGE_TRANSFORM_CATEGORY);

  return (
    <Seo
      noSuffix
      image={imageUrl}
      noIndex={noIndex}
      metaTitle={metaTitle}
      metaDescr={metaDescription}
      canonicalUrl={canonicalUrl}
    />
  );
};
